<template>
  <div class="update-table-size">
    <whole-multiselect :options="tableSizeOptions"
        class="whole-multiselect" v-model="tableSize" trackBy="id" :showDescription="true"/>
  </div>
</template>
<script>
import mixins from "@/Mixins.js";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";

export default {
  mixins: [mixins],
  components: { WholeMultiselect },
  data() {
    return {
      tableSizeOptions: [
        {id: 5, description:"Exibir 5 linhas"},
        {id: 10, description:"Exibir 10 linhas"},
        {id: 20, description:"Exibir 20 linhas"},
        {id: 50, description:"Exibir 50 linhas"},
        {id: 100, description:"Exibir 100 linhas"},
      ],
      tableSize: {id: 10, description:"Exibir 10 linhas"},
    };
  },
  watch: {
    tableSize: function (newVal) {
      const vm = this;
      vm.tableSize = vm.testNullUndefinedEmpty(newVal) ? {id: 10, description:"Exibir 10 linhas"} : newVal;
      vm.$emit('size',vm.tableSize.id);
    },
  },
};
</script>
<style lang="scss">
.update-table-size {
  .whole-multiselect {
    margin-bottom: 30px;
    .multiselect {
      color:#ff9f43 !important;
      z-index: 900 !important;
    }
    .multiselect__tags {
      border-color: #ff9f43 !important;
    }
    .multiselect__placeholder {
      color: #ff9f43 !important;
      font-size: 0.99rem !important;
    }
    .multiselect__input {
      color: #ff9f43 !important;
      font-size: 0.99rem !important;
    }
    .multiselect__select {
      color:#ff9f43 !important;
      border-top-color: #ff9f43 !important;
    }
    .multiselect__select:before {
        border-top-color: #ff9f43 !important;
    }
  }
}
</style>